<script lang="ts" setup>
import type { RefresherCustomEvent } from '@ionic/vue';

defineExpose({ open });
const { t } = useEkI18n();
const appApiFetch = getAppApiFetch();

const { usingTouch } = useInputTracker();

const isOpen = ref<boolean>(false);
const localItem = ref<MaterialItemApp | undefined>();
const locationItemHistory = ref<ResponseDTO<LocationItemHistoryDTO[]>>();
const response = ref();

async function open(item: MaterialItemApp | undefined) {
  isOpen.value = true;
  localItem.value = item;

  if (item?.RecordId) {
    locationItemHistory.value = await appApiFetch<ResponseDTO<LocationItemHistoryDTO[]>>(versionedUrl('Inventory/GetLocationItemHistoryForLocationItemIds'), { method: 'POST', body: [item?.RecordId] });
  }
}

async function handleRefresh(event: RefresherCustomEvent) {
  await response.value.refresh();
  event.target.complete();
}
</script>

<template>
  <Modal
    :open="isOpen"
    :title="localItem?.Location?.Name ?? t('labels.notAvailable')"
    animation-direction="vertical"
    :close-override="() => isOpen = false"
  >
    <IonContent>
      <IonRefresher
        slot="fixed"
        close-duration="1000ms"
        :disabled="!usingTouch"
        @ion-refresh="handleRefresh($event)"
      >
        <IonRefresherContent />
      </IonRefresher>
      <MaterialItemLookUp
        v-if="localItem"
        :item="localItem"
        item-type="locations"
        :show-favorite-button="false"
      />
      <IonListHeader>
        <IonLabel>{{ t('buttons.movements') }}</IonLabel>
      </IonListHeader>
      <IonList>
        <MaterialItemLocationHistory
          v-for="movement in locationItemHistory?.Data"
          :key="movement.Ean"
          :item-history="movement"
        />
      </IonList>
    </IonContent>
  </Modal>
</template>

<style scoped>

</style>
